import { useStripes } from '@folio/stripes/core';
export function useListAppPermissions() {
    var stripes = useStripes();
    return {
        canRefresh: stripes.hasPerm("lists.item.post" /* USER_PERMS.RefreshList */),
        canUpdate: stripes.hasPerm("lists.item.update" /* USER_PERMS.UpdateList */),
        canDelete: stripes.hasPerm("lists.item.delete" /* USER_PERMS.DeleteList */),
        canExport: stripes.hasPerm("lists.item.export.get" /* USER_PERMS.ExportList */),
        canCreate: stripes.hasPerm("lists.collection.post" /* USER_PERMS.CreateList */),
    };
}
